import { ITrayFileListVM } from '../../models/response/ITrayResponse';
const initialTrayFilesState: ITrayFileListVM = {
  PagingDetails: {
    TotalRecords: 1,
    TotalPages: 1,
    CurrentPage: 1,
    PageSize: 10,
  },
  ImportStatusList: [],
};

export default initialTrayFilesState;
